import { useQuery } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

interface IUser {
  profilePic: string;
  username: string;
  firstname: string;
}

const useUser = <T extends Record<string, any> = IUser>(
  ...usersIds: string[]
) => {
  return useQuery({
    queryKey: ["user", ...usersIds],
    queryFn: async () => {
      return (
        await httpsCallable(
          functions,
          "users-getUserInfoForView"
        )({
          uuids: usersIds,
        })
      ).data as T[];
    },
  });
};

export default useUser;
export { type IUser };
